<template>
  <div>
    <div v-if="loading" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
    <form
      v-if="client"
      v-show="!loading"
      id="employmentForm"
      ref="employmentForm"
      method="POST"
      class="ang-card-body"
      :action="action"
    >
      <input type="hidden" name="data[step_2]" value="1" />
      <input type="hidden" name="code" :value="code" />
      <div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Staż pracy ogółem (w latach)</label>
              <input
                type="text"
                class="ang-form-control dig"
                name="data[details][job_experience]"
                v-model="client.data.details.job_experience"
              />
            </div>
          </div>
        </div>
        <div v-for="(e, i) in client.data.employment" :key="'employment_' + i">
          <div class="row">
            <div class="col-12 d-flex">
              <div class="ang-card-title mt-3">
                Źródło dochodów<span
                  class="ml-2"
                  v-if="client.data.employment.length > 1"
                >
                  {{ i + 1 }}</span
                >
              </div>
              <div class="ml-auto" v-if="i > 0">
                <button
                  class="mt-3 btn btn-lg ang-button _bg_color2"
                  @click.stop.prevent="removeEmployer(i)"
                >
                  Usuń
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Forma umowy/zatrudnienia</label>
                <select-field
                  :name="'data[employment][' + i + '][contract_type]'"
                  css="width: 100%"
                  placeholder="Wybierz"
                  :options="employmentTypes"
                  required
                  v-model="e.contract_type"
                  :selected="e.contract_type"
                  @changed="refreshForm"
                ></select-field>
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-show="e.contract_type === 'działalność gospodarcza'"
            >
              <div class="form-group">
                <label class="ang-form-label">Forma rozliczania z US</label>
                <select-field
                  :name="'data[employment][' + i + '][contract_self_type]'"
                  css="width: 100%"
                  placeholder="Wybierz"
                  @changed="refreshForm"
                  :options="{
                    values: [
                      { text: 'pełna księgowość', val: 'pełna księgowość' },
                      {
                        text: 'KPiR (zasady ogólne)',
                        val: 'KPiR (zasady ogólne)',
                      },
                      { text: 'Ryczałt', val: 'Ryczałt' },
                      { text: 'Karta podatkowa', val: 'Karta podatkowa' },
                    ],
                  }"
                  v-model="e.contract_self_type"
                  :selected="e.contract_self_type"
                ></select-field>
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-show="e.contract_type !== 'brak źródła dochodu'"
            >
              <div class="form-group">
                <label
                  class="ang-form-label"
                  v-if="
                    e.contract_type ===
                    'dywidenda / udział w spółce (z o.o./S.A.)'
                  "
                  >Data rozpoczęcia uzyskiwania dochodu</label
                >
                <label
                  class="ang-form-label"
                  v-else-if="e.contract_type === 'działalność gospodarcza'"
                  >Data rozpoczęcia prowadzenia DG</label
                >
                <label
                  class="ang-form-label"
                  v-else-if="
                    e.contract_type && e.contract_type.indexOf('renta') >= 0
                  "
                  >Data przyznania renty</label
                >
                <label
                  class="ang-form-label"
                  v-else-if="
                    e.contract_type && e.contract_type.indexOf('emerytura') >= 0
                  "
                  >Data przejścia na emeryturę</label
                >
                <label class="ang-form-label" v-else>Data zatrudnienia</label>
                <input
                  type="text"
                  class="ang-form-control dateISO datepicker dateBeforeNow dateCorrect"
                  :data-index="i"
                  :id="'employed_at_' + i"
                  :name="'data[employment][' + i + '][employed_at]'"
                  v-model="e.employed_at"
                />
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-show="
                e.contract_type === 'umowa o pracę na czas określony' ||
                e.contract_type === 'renta terminowa'
              "
            >
              <div class="form-group">
                <label
                  class="ang-form-label"
                  v-if="e.contract_type === 'renta terminowa'"
                  >Data końca przyznanej renty</label
                >
                <label class="ang-form-label" v-else>Data końca umowy</label>
                <input
                  type="text"
                  class="ang-form-control dateISO datepicker"
                  :name="'data[employment][' + i + '][contract_end]'"
                  v-model="e.contract_end"
                />
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-show="e.contract_type === 'inna forma dochodu'"
            >
              <div class="form-group">
                <label class="ang-form-label">Opis formy zatrudnienia</label>
                <input
                  type="text"
                  class="ang-form-control"
                  :name="
                    'data[employment][' + i + '][contract_type_description]'
                  "
                  v-model="e.contract_type_description"
                />
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-show="e.contract_type !== 'brak źródła dochodu'"
            >
              <div class="form-group">
                <label class="ang-form-label">Branża</label>
                <select-field
                  :name="'data[employment][' + i + '][industry]'"
                  css="width: 100%"
                  placeholder="Wybierz"
                  :options="industryList"
                  v-model="e.industry"
                  :selected="e.industry"
                ></select-field>
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-show="e.contract_type !== 'brak źródła dochodu'"
            >
              <div class="form-group">
                <label class="ang-form-label"
                  >Rodzaj zakładu pracy / forma prawna</label
                >
                <select-field
                  :name="'data[employment][' + i + '][workplace_type]'"
                  css="width: 100%"
                  placeholder="Wybierz"
                  @changed="refreshForm"
                  :options="dictionary.workplaceTypes"
                  v-model="e.workplace_type"
                  :selected="e.workplace_type"
                ></select-field>
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-show="e.contract_type !== 'brak źródła dochodu'"
            >
              <div class="form-group">
                <label class="ang-form-label">Stanowisko</label>
                <select-field
                  css="width: 100%"
                  placeholder="Wybierz"
                  :name="'data[employment][' + i + '][position]'"
                  @changed="refreshForm"
                  :options="dictionary.positionTypes"
                  v-model="e.position"
                  :selected="e.position"
                ></select-field>
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-show="e.contract_type !== 'brak źródła dochodu'"
            >
              <div class="form-group">
                <label class="ang-form-label">Staż pracy (w miesiącach)</label>
                <input
                  type="text"
                  class="ang-form-control dig"
                  :name="'data[employment][' + i + '][job_experience]'"
                  v-model="e.job_experience"
                />
              </div>
            </div>
            <div
              class="col-12 col-md-4"
              v-if="
                e.contract_type &&
                (e.contract_type.indexOf('renta') >= 0 ||
                  e.contract_type.indexOf('emerytura') >= 0)
              "
            >
              <div class="form-group">
                <label
                  class="ang-form-label"
                  v-if="e.contract_type.indexOf('renta') >= 0"
                  >Kwota renty (ostatni miesiąc)</label
                >
                <label class="ang-form-label" v-else
                  >Kwota emerytury (ostatni miesiąc)</label
                >
                <input
                  type="text"
                  class="ang-form-control dig"
                  :name="'data[employment][' + i + '][salary_1]'"
                  v-model="e.salary_1"
                />
              </div>
            </div>
            <template v-else-if="e.contract_type !== 'brak źródła dochodu'">
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label"
                    >Wynagrodzenie netto z ostatniego miesiąca</label
                  >
                  <currency-field
                    :name="'data[employment][' + i + '][salary_1]'"
                    :notrequired="true"
                    v-if="e.salary_1"
                    v-model="e.salary_1"
                  ></currency-field>
                  <currency-field
                    :name="'data[employment][' + i + '][salary_1]'"
                    :notrequired="true"
                    v-else
                  ></currency-field>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label"
                    >Śr. wynagrodzenie netto z ostatnich 3 m-cy</label
                  >
                  <currency-field
                    :name="'data[employment][' + i + '][salary_3]'"
                    :notrequired="true"
                    v-if="e.salary_3"
                    v-model="e.salary_3"
                  ></currency-field>
                  <currency-field
                    :name="'data[employment][' + i + '][salary_3]'"
                    :notrequired="true"
                    v-else
                  ></currency-field>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label"
                    >Śr. wynagrodzenie netto z ostatnich 6 m-cy</label
                  >
                  <currency-field
                    :name="'data[employment][' + i + '][salary_6]'"
                    :notrequired="true"
                    v-if="e.salary_6"
                    v-model="e.salary_6"
                  ></currency-field>
                  <currency-field
                    :name="'data[employment][' + i + '][salary_6]'"
                    :notrequired="true"
                    v-else
                  ></currency-field>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label"
                    >Śr. wynagrodzenie netto z ostatnich 12 m-cy</label
                  >
                  <currency-field
                    :name="'data[employment][' + i + '][salary_12]'"
                    :notrequired="true"
                    v-if="e.salary_12"
                    v-model="e.salary_12"
                  ></currency-field>
                  <currency-field
                    :name="'data[employment][' + i + '][salary_12]'"
                    :notrequired="true"
                    v-else
                  ></currency-field>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label">Waluta dochodu</label>
                  <select-field
                    css="width: 100%"
                    :name="'data[employment][' + i + '][income_currency]'"
                    placeholder="Wybierz"
                    @changed="refreshForm"
                    :options="dictionary.incomeCurrency"
                    v-model="e.income_currency"
                    :selected="e.income_currency"
                  ></select-field>
                </div>
              </div>
            </template>
          </div>
          <div
            v-if="
              e.contract_type &&
              employmentConfig[e.contract_type] &&
              employmentConfig[e.contract_type].company
            "
          >
            <div class="row">
              <div class="col-12 mb-2 mt-2">
                <strong>Dane pracodawcy/firmy</strong>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label">NIP</label>
                  <input
                    type="text"
                    class="ang-form-control dig nip"
                    @input="fetchCompanyData($event, i)"
                    :name="'data[employment][' + i + '][nip]'"
                    v-model="e.nip"
                  />
                </div>
              </div>
              <div class="col-12 col-md-4">
                <spinner
                  v-if="fetchingCompany === i"
                  class="little-lower"
                ></spinner>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label">REGON</label>
                  <input
                    type="text"
                    class="ang-form-control regon"
                    :name="'data[employment][' + i + '][company][regon]'"
                    v-model="e.company.regon"
                    :disabled="e.disabled"
                  />
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label">Nazwa</label>
                  <input
                    type="text"
                    class="ang-form-control"
                    :name="'data[employment][' + i + '][company][name]'"
                    v-model="e.company.name"
                    :disabled="e.disabled"
                  />
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label">Ulica</label>
                  <input
                    type="text"
                    class="ang-form-control"
                    :name="'data[employment][' + i + '][company][street]'"
                    v-model="e.company.street"
                  />
                </div>
              </div>
              <div class="col-6 col-md-2">
                <div class="form-group">
                  <label class="ang-form-label">Numer budynku</label>
                  <input
                    type="text"
                    class="ang-form-control"
                    :name="'data[employment][' + i + '][company][number]'"
                    v-model="e.company.number"
                  />
                </div>
              </div>
              <div class="col-6 col-md-2">
                <div class="form-group">
                  <label class="ang-form-label">Numer lokalu</label>
                  <input
                    type="text"
                    class="ang-form-control"
                    :name="'data[employment][' + i + '][company][flat]'"
                    v-model="e.company.flat"
                  />
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label">Kod pocztowy</label>
                  <input
                    type="text"
                    class="ang-form-control postal"
                    :name="'data[employment][' + i + '][company][postal]'"
                    v-model="e.company.postal"
                  />
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label">Miasto</label>
                  <input
                    type="text"
                    class="ang-form-control"
                    :name="'data[employment][' + i + '][company][city]'"
                    v-model="e.company.city"
                  />
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="ang-form-label">Województwo</label>
                  <select-field
                    :name="'data[employment][' + i + '][company][province]'"
                    css="width: 100%"
                    :options="dictionary.provinces"
                    @changed="refreshForm"
                    v-model="e.company.province"
                    :selected="e.company.province"
                  ></select-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
        <h5 class="ang-card-title">Wystąpił błąd!</h5>
        <label class="form-error error">{{ error }}</label>
      </div>
      <div class="d-flex">
        <div>
          <button
            class="btn ang-button _bg_color3 mt-1"
            @click.stop.prevent="$emit('backward')"
          >
            Wstecz
          </button>
        </div>
        <div class="ml-auto">
          <spinner v-if="sending"></spinner>
          <div v-else>
            <button
              class="btn ang-button _bg_color2 spinn mr-2"
              @click.stop.prevent="addEmployer"
            >
              Dodaj kolejne źródło dochodu
            </button>
            <button
              type="submit"
              class="btn btn-lg ang-button ang-btn-lg spinn"
            >
              Dalej
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ajax from "@/services/ajax";
import api from "@/services/api";
import dictionary from "@/services/dictionary";
import spinner from "@/components/partials/misc/spinner";
import datepicker from "eonasdan-bootstrap-datetimepicker"; // eslint-disable-line
import select from "@/components/partials/misc/select";
import currency from "@/components/partials/misc/currency";
import $ from "jquery";
import moment from "moment";

export default {
  data() {
    return {
      success: false,
      error: null,
      sending: false,
      fetchingCompany: false,
      loading: true,
      client: null,
      industryList: {
        values: [
          { text: "Górnictwo", val: "Górnictwo" },
          {
            text: "Służby mundurowe (Policja, Wojsko, SW,SG,…)",
            val: "Służby mundurowe (Policja, Wojsko, SW,SG,…)",
          },
          { text: "Usługi", val: "Usługi" },
          { text: "Produkcja/przetwórstwo", val: "Produkcja/przetwórstwo" },
          { text: "Handel", val: "Handel" },
          { text: "Edukacja", val: "Edukacja" },
          {
            text: "Ochrona zdrowia/Opieka społeczna",
            val: "Ochrona zdrowia/Opieka społeczna",
          },
          { text: "Bankowość", val: "Bankowość" },
          { text: "Transport", val: "Transport" },
          { text: "Administracja państwowa", val: "Administracja państwowa" },
          { text: "Wymiar sprawiedliwości", val: "Wymiar sprawiedliwości" },
          { text: "Budownictwo", val: "Budownictwo" },
          { text: "Rolnictwo", val: "Rolnictwo" },
          { text: "Leśnictwo", val: "Leśnictwo" },
          { text: "Ubezpieczenia", val: "Ubezpieczenia" },
          { text: "Turystyka/ rekreacja", val: "Turystyka/ rekreacja" },
          { text: "Marketing i reklama", val: "Marketing i reklama" },
          { text: "Informatyka", val: "Informatyka" },
          { text: "Przemysł", val: "Przemysł" },
          { text: "Telekomunikacja", val: "Telekomunikacja" },
          { text: "Usługi finansowe", val: "Usługi finansowe" },
          { text: "Inna", val: "Inna" },
        ],
      },
      employmentConfig: {},
      employmentTypes: {
        values: [
          {
            company: true,
            nip: true,
            text: "umowa o pracę na czas nieokreślony",
            val: "umowa o pracę na czas nieokreślony",
          },
          {
            company: true,
            nip: true,
            text: "umowa o pracę na czas określony",
            val: "umowa o pracę na czas określony",
          },
          {
            company: true,
            nip: false,
            text: "kontrakt marynarski",
            val: "kontrakt marynarski",
          },
          {
            company: true,
            nip: true,
            text: "kontrakt menedżerski",
            val: "kontrakt menedżerski",
          },
          {
            company: true,
            nip: true,
            text: "mianowanie / powołanie / nominacja",
            val: "mianowanie / powołanie / nominacja",
          },
          {
            company: true,
            nip: true,
            text: "działalność gospodarcza",
            val: "działalność gospodarcza",
          },
          { company: false, nip: false, text: "emerytura", val: "emerytura" },
          {
            company: false,
            nip: false,
            text: "renta terminowa",
            val: "renta terminowa",
          },
          {
            company: false,
            nip: false,
            text: "renta bezterminowa",
            val: "renta bezterminowa",
          },
          {
            company: false,
            nip: false,
            text: "świadczenie przedemerytalne",
            val: "świadczenie przedemerytalne",
          },
          {
            company: false,
            nip: false,
            text: "renta strukturalna",
            val: "renta strukturalna",
          },
          {
            company: false,
            nip: false,
            text: "wynajem nieruchomości (poza działalnością gospodarczą)",
            val: "wynajem nieruchomości (poza działalnością gospodarczą)",
          },
          {
            company: true,
            nip: true,
            text: "umowa o dzieło",
            val: "umowa o dzieło",
          },
          {
            company: true,
            nip: true,
            text: "umowa zlecenia",
            val: "umowa zlecenia",
          },
          {
            company: true,
            nip: true,
            text: "dział specjalny produkcji rolnej – pełna księgowość lub KPiR",
            val: "dział specjalny produkcji rolnej – pełna księgowość lub KPiR",
          },
          {
            company: true,
            nip: true,
            text: "dział specjalny produkcji rolnej",
            val: "dział specjalny produkcji rolnej",
          },
          {
            company: true,
            nip: false,
            text: "prowadzenie gospodarstwa rolnego",
            val: "prowadzenie gospodarstwa rolnego",
          },
          {
            company: true,
            nip: true,
            text: "dywidenda / udział w spółce (z o.o./S.A.)",
            val: "dywidenda / udział w spółce (z o.o./S.A.)",
          },
          {
            company: true,
            nip: true,
            text: "kontrakt sportowy",
            val: "kontrakt sportowy",
          },
          {
            company: true,
            nip: false,
            text: "inna forma dochodu",
            val: "inna forma dochodu",
          },
          {
            company: false,
            nip: false,
            text: "brak",
            val: "brak źródła dochodu",
          },
        ],
      },
    };
  },
  props: ["base_client", "base", "code"],
  mixins: [dictionary],
  components: {
    spinner,
    "select-field": select,
    "currency-field": currency,
  },
  watch: {
    base_client() {
      let self = this;
      this.client = this.base_client;
      if (typeof this.client.data.employment === "undefined") {
        this.client.data.employment = [
          {
            company: {},
          },
        ];
      }
      this.$nextTick(function () {
        self.loading = false;
        self.hookDatepickers();
      });
    },
  },
  name: "employmentForm",
  computed: {
    action() {
      return "/client/details/" + this.base;
    },
  },
  mounted() {
    let self = this;
    for (let i = 0; i < this.employmentTypes.values.length; i++) {
      this.employmentConfig[this.employmentTypes.values[i].val] = {
        nip: this.employmentTypes.values[i].nip,
        company: this.employmentTypes.values[i].company,
      };
    }

    this.client = this.base_client;
    if (typeof this.client.data.employment === "undefined") {
      this.client.data.employment = [
        {
          company: {},
        },
      ];
    }
    for (let i = 0; i < this.client.data.employment.length; i++) {
      if (typeof this.client.data.employment[i].company === "undefined") {
        this.client.data.employment[i].company = {};
      }
    }

    this.$nextTick(function () {
      self.loading = false;
      ajax.postValidate(
        $(self.$refs.employmentForm),
        self,
        function (form, vm, data) {
          self.sending = false;
          self.$emit("forward", data);
        },
        function (data) {
          self.error = data.message;
          self.sending = false;
          $("html,body").animate({ scrollTop: $(document).height() }, "slow");
        },
        function () {
          self.error = null;
          self.sending = true;
        }
      );
      this.hookDatepickers();
    });
  },
  methods: {
    refreshForm() {
      this.$forceUpdate();
    },
    checkNip(value) {
      var verificator_nip = new Array(6, 5, 7, 2, 3, 4, 5, 6, 7);
      var nip = value.replace(/[ -]/gi, "");
      if (nip.length != 10 && nip.length != 0) {
        return false;
      } else if (nip.length != 0) {
        var n = 0;
        for (var i = 0; i < 9; i++) {
          n += nip[i] * verificator_nip[i];
        }
        n %= 11;
        if (n != nip[9]) {
          return false;
        }
      }
      return true;
    },
    fixRegon(regon) {
      var lastFive = regon.substr(regon.length - 5);
      if (lastFive == "00000") {
        return "" + regon.substring(0, regon.length - 5);
      }
      return regon;
    },
    fetchCompanyData(object, i) {
      let self = this;
      if (this.checkNip(object.target.value)) {
        api.get(
          "/bir/" + object.target.value,
          {},
          function (data) {
            self.client.data.employment[i].company = {
              ...data,
              regon: self.fixRegon(data.regon),
            };
            $(
              'select[name="data[employment][' + i + '][company][province]"]'
            ).val(data.district.toLowerCase());
            $(
              'select[name="data[employment][' + i + '][company][province]"]'
            ).change();
            self.fetchingCompany = false;
            self.$forceUpdate();
          },
          function () {
            self.fetchingCompany = false;
          },
          function () {
            self.fetchingCompany = i;
          }
        );
      }
    },
    addEmployer() {
      this.client.data.employment.push({
        company: {},
      });
      this.$forceUpdate();
      this.hookDatepickers();
    },
    hookDatepickers() {
      let self = this;
      this.$nextTick(function () {
        $(".datepicker")
          .datetimepicker({
            locale: "pl",
            format: "YYYY-MM-DD",
          })
          .on("change", function () {
            $(this).valid();
          })
          .unbind("change")
          .unbind("dp.change")
          .on("dp.change", function (e) {
            if (
              typeof $(e.target).data("index") !== "undefined" &&
              $(e.target).attr("name").indexOf("employed_at") >= 0
            ) {
              let mnts = moment().diff(moment($(e.target).val()), "months");
              // console.log(mnts)
              self.client.data.employment[
                parseInt($(e.target).data("index"))
              ].job_experience = mnts;
              self.$forceUpdate();
            }
            let event = document.createEvent("HTMLEvents");
            event.initEvent("input", true, true);
            e.currentTarget.dispatchEvent(event);
            $(this).trigger("change");
            $(this).valid();
          });
      });
    },
    removeEmployer(i) {
      this.client.data.employment.splice(i, 1);
      this.$forceUpdate();
    },
    scrollToAnchor(aid) {
      console.log(aid);
      let aTag = $("#" + aid);
      if (typeof aTag !== "undefined" && typeof aTag.offset() !== "undefined") {
        $("html,body").animate({ scrollTop: aTag.offset().top - 160 }, "slow");
      }
    },
  },
};
</script>
